import { Component, Input, OnChanges } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-zoho-dashboard",
  templateUrl: "./zoho-dashboard.component.html",
  styleUrls: ["./zoho-dashboard.component.scss"],
})
export class ZohoDashboardComponent implements OnChanges {
  @Input() reportUrl: any;
  @Input() title: any;
  safeUrl: SafeResourceUrl | null = null;
  isInvalid = false;
  isLoading = false;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    if (!this.reportUrl) {
      return;
    }
    this.isLoading = true;
    if (!this.reportUrl || !this.isValidUrl(this.reportUrl)) {
      this.isInvalid = true;
      this.safeUrl = null;
      this.isLoading = false;
    } else {
      this.isInvalid = false;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.reportUrl
      );
      this.isLoading = false;
    }
  }

  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }
}
